export default {
  picks: {
    imageImport: {
      dropzoneBody: "Import a photo and we will grab the picks for you.",
      dropzoneCta: "Click here or drag and drop to upload",
      preparingResults: "Preparing results",
      adding: "Adding...",
      importedPicks: "Imported picks",
    },
    actions: {
      findTrends: "Find trends",
    },
    labels: {
      sgpPricingUnavailable: "SGP pricing not available",
    },
    plusPromo: {
        description: "Get access to advanced plays & deeper insights",
    },
  },
};